import Home from "./containers/Home/Home";
import Nav from "./components/Nav/Nav";
import "animate.css";

function App() {
  return (
    <>
      <Nav />
      <Home />
    </>
  );
}

export default App;
